/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetClientCapabilitiesAndBusinessLineQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetClientCapabilitiesAndBusinessLineQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    id: string;
    firstName: string;
    businessLine: Types.BusinessLine;
    isAuthenticatedClient: boolean;
    capabilities: { __typename?: "ClientCapabilities"; canShop: boolean };
  } | null;
};

export const GetClientCapabilitiesAndBusinessLineDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getClientCapabilitiesAndBusinessLine" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "businessLine" } },
                { kind: "Field", name: { kind: "Name", value: "isAuthenticatedClient" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "capabilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "canShop" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetClientCapabilitiesAndBusinessLineQuery__
 *
 * To run a query within a React component, call `useGetClientCapabilitiesAndBusinessLineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientCapabilitiesAndBusinessLineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientCapabilitiesAndBusinessLineQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientCapabilitiesAndBusinessLineQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetClientCapabilitiesAndBusinessLineQuery,
    GetClientCapabilitiesAndBusinessLineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetClientCapabilitiesAndBusinessLineQuery,
    GetClientCapabilitiesAndBusinessLineQueryVariables
  >(GetClientCapabilitiesAndBusinessLineDocument, options);
}
export function useGetClientCapabilitiesAndBusinessLineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientCapabilitiesAndBusinessLineQuery,
    GetClientCapabilitiesAndBusinessLineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClientCapabilitiesAndBusinessLineQuery,
    GetClientCapabilitiesAndBusinessLineQueryVariables
  >(GetClientCapabilitiesAndBusinessLineDocument, options);
}
// @ts-ignore
export function useGetClientCapabilitiesAndBusinessLineSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetClientCapabilitiesAndBusinessLineQuery,
    GetClientCapabilitiesAndBusinessLineQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetClientCapabilitiesAndBusinessLineQuery,
  GetClientCapabilitiesAndBusinessLineQueryVariables
>;
export function useGetClientCapabilitiesAndBusinessLineSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetClientCapabilitiesAndBusinessLineQuery,
        GetClientCapabilitiesAndBusinessLineQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetClientCapabilitiesAndBusinessLineQuery | undefined,
  GetClientCapabilitiesAndBusinessLineQueryVariables
>;
export function useGetClientCapabilitiesAndBusinessLineSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetClientCapabilitiesAndBusinessLineQuery,
        GetClientCapabilitiesAndBusinessLineQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetClientCapabilitiesAndBusinessLineQuery,
    GetClientCapabilitiesAndBusinessLineQueryVariables
  >(GetClientCapabilitiesAndBusinessLineDocument, options);
}
export type GetClientCapabilitiesAndBusinessLineQueryHookResult = ReturnType<
  typeof useGetClientCapabilitiesAndBusinessLineQuery
>;
export type GetClientCapabilitiesAndBusinessLineLazyQueryHookResult = ReturnType<
  typeof useGetClientCapabilitiesAndBusinessLineLazyQuery
>;
export type GetClientCapabilitiesAndBusinessLineSuspenseQueryHookResult = ReturnType<
  typeof useGetClientCapabilitiesAndBusinessLineSuspenseQuery
>;
export type GetClientCapabilitiesAndBusinessLineQueryResult = Apollo.QueryResult<
  GetClientCapabilitiesAndBusinessLineQuery,
  GetClientCapabilitiesAndBusinessLineQueryVariables
>;
